// extracted by mini-css-extract-plugin
export default {"container":"_8lfAEsu+oUfn-jmHKQ2m9g==","card-fields":"mji4qh0eaFmMZcjPoYwaQQ==","inline":"+oLMhIVtPHV-JKSMICXGVA==","footnote":"tDatkVUpLzoSY3adR9YnZw=="};